<pannel [title]="'Filtres'" [expandable]="true" [folded]="true">
	<form role="form" class="form-horizontal">
		
		<div class="form-group row">
			<label class="control-label col-md-1 plus-half">N° accès</label>
			<div class="col-md-2 plus-half">
				<suggestable-input
					[inputClass]="'form-control'"
					[labelGetter]="getSuggestionsLabel"
					[suggestionsObservableGetter]="observablePourSuggestionNumAcces"
					[(value)] = "searchCriteria.numeroAcces"
					(valueChange) = "onNumeroAccesChange($event)"
					>
				</suggestable-input>
			</div>
			<div class="col-md-2 plus-half"></div>
			<div class="col-md-1"></div>
			<label [for]="'monPerimetreCac'" class="control-label col-md-2 plus-half">Mon périmètre CAC</label>
			<div class="col-md-1 perimetre-cb">
				<input id="monPerimetreCac" type="checkbox" [(ngModel)]="searchCriteria.monPerimetreCac" />
			</div>
		</div>
		<div class="form-group">
			<agence-filterable-selector
				[id]="'filtreAgence'"
				[disabled]="userRole !== 'CCE'"
				[labelClass]="'col-md-1 plus-half'"
				[fieldClass]="'col-md-2 plus-half'"
				[selectedAgenceId]="searchCriteria.agence"
				(selectedAgenceChange)="onAgenceChange($event)"
				>
			</agence-filterable-selector>
			<antenne-filterable-selector
				[id]="'filtreAntenne'"
				[disabled]="userRole !== 'CCE'"
				[labelClass]="'col-md-1'"
				[fieldClass]="'col-md-2 plus-half'"
				[agenceId]="searchCriteria.agence"
				[selectedAntenneId]="searchCriteria.antenne"
				(selectedAntenneChange)="onAntenneChange($event)"
				>
			</antenne-filterable-selector>
			<label [for]="'monPerimetreCc'" class="control-label col-md-2 plus-half">Mon périmètre CC</label>
			<div class="col-md-1 perimetre-cb">
				<input id="monPerimetreCc" type="checkbox" [(ngModel)]="searchCriteria.monPerimetreCc" />
			</div>
		</div>
		<div class="form-group">
			<groupement-filterable-selector
				[id]="'filtreGroupement'"
				[labelClass]="'col-md-1 plus-half'"
				[fieldClass]="'col-md-2 plus-half'"
				[agenceId]="searchCriteria.agence"
				[antenneId]="searchCriteria.antenne"
				[selectedGroupementId]="searchCriteria.groupement"
				(selectedGroupementChange)="onGroupementChange($event)"
				>
			</groupement-filterable-selector>
			<parc-filterable-selector
				[id]="'filtreParc'"
				[labelClass]="'col-md-1'"
				[fieldClass]="'col-md-2 plus-half'"
				[agenceId]="searchCriteria.agence"
				[antenneId]="searchCriteria.antenne"
				[groupementId]="searchCriteria.groupement"
				[selectedParcId]="searchCriteria.parc"
				(selectedParcChange)="onParcChange($event)"
				>
			</parc-filterable-selector>
			<label [for]="'monPerimetreReferent'" class="control-label col-md-2 plus-half">Mon périmètre de Référent de Parc</label>
			<div class="col-md-1 perimetre-cb">
				<input id="monPerimetreReferent" type="checkbox" [(ngModel)]="searchCriteria.monPerimetreReferent" />
			</div>
		</div>
		<div class="form-group" *ngIf="this.searchCriteria.parc">
			<ouvrage-checkbox-list
				[id]="'choixOuvrages'"
				[labelClass]="'col-md-1 plus-half'"
				[fieldClass]="'col-md-10'"
				[parcIds]="searchCriteria.parc ? [searchCriteria.parc] : []"
				(selectionIdsChange)="onOuvragesChange($event)" >
			</ouvrage-checkbox-list>
		</div>
		<div class="form-group">
			<label class="control-label col-md-1 plus-half">Valideur</label>
			<div class="col-md-2 plus-half">
				<extended-filterable-select [inputClass]="'form-control'" [list]="valideurs" [resetCommand]="resetCommands" 
					[labelGetter]="getValideurName" (selectedItemChange) = "onValideurSelected($event)">
				</extended-filterable-select>
			</div>
			<label class="col-md-1 control-label" for="entreprise">Entreprise</label>
			<div class="col-md-2 plus-half" >
				<extended-filterable-select [inputClass]="'form-control'" [list]="entreprises" [resetCommand]="resetCommands" 
					[labelGetter]="getEntrepriseName" (selectedItemChange)="onEntrepriseSelected($event)" >
				</extended-filterable-select>
			</div>
			<label *ngIf="showFiltreTarifNegatif" [for]="'tarifNegatif'" class="control-label col-md-2 plus-half">Coactivité Pilotage économique</label>
			<div *ngIf="showFiltreTarifNegatif" class="col-md-1 perimetre-cb">
				<input id="tarifNegatif" type="checkbox" [(ngModel)]="searchCriteria.coactivitePilotageEco"/>
			</div>
		</div>
		<div class="form-group">
			<label class="control-label col-md-1 plus-half">Date de début</label>
			<div class="col-md-2 plus-half">
				<select id="typeCritere" name="typeCritere" class="form-control" [(ngModel)]="typeCritereDate" (change)="typeCritereChange()" >
					<option value="">---</option>
					<option value="PERIODE">Inférieur à</option>
					<option value="BORNE_INF_SUP">Compris entre</option>
				</select>
			</div>
			<label class="col-md-1 control-label" for="dateDebut" *ngIf="typeCritereDate === 'BORNE_INF_SUP'">Entre le</label>
			<div class="col-md-2 plus-half" *ngIf="typeCritereDate === 'BORNE_INF_SUP'">
				<date-input
					[id]="'inputFiltreDateDebut'"
					[localDateMax]="searchCriteria.dateMax"
					[localDate]="searchCriteria.dateMin"
					(localDateChange)="onDateDebutChange($event)"
					>
				</date-input>
			</div>
			<label class="col-md-1 control-label" for="dateFin" *ngIf="typeCritereDate === 'BORNE_INF_SUP'"> et le</label>
			<div class="col-md-2 plus-half" *ngIf="typeCritereDate === 'BORNE_INF_SUP'">
				<date-input
					[id]="'inputFiltreDateFin'"
					[localDateMin]="searchCriteria.dateMin"
					[localDate]="searchCriteria.dateMax"
					(localDateChange)="onDateFinChange($event)"
					>
				</date-input>
			</div>
			<label class="col-md-1 control-label" for="dateDebut" *ngIf="typeCritereDate === 'PERIODE'">Période</label>
			<div class="col-md-2 plus-half" *ngIf="typeCritereDate === 'PERIODE'">
				<p class="input-group">
		          <input id="quantite" name="quantite" type="number" autocomplete="off" class="form-control" min="1" [(ngModel)]="searchCriteria.critereDate" />
		          <span class="input-group-addon">jours</span>
		        </p>
			</div>
			
			<label *ngIf="showFiltreTarifNegatif" for="masqueCoactivite" class="control-label col-md-2 plus-half">Masquer les accès pilotage économique</label>
			<div *ngIf="showFiltreTarifNegatif" class="col-md-1 perimetre-cb">
				<input id="masqueCoactivite" type="checkbox" [(ngModel)]="searchCriteria.masquerPilotageEco" />
			</div>
		</div>
		<div class="form-group">
			<parc-maintenance-checkbox-list [id]="'choixMaintenance'"
				[labelClass]="'col-md-1 plus-half'" [fieldClass]="'col-md-2 plus-half no-padding-right'"
				[resetCommands]="resetCommands" (selectionIdsChange)="parcMaintenanceFilterChange($event)"
				>
			</parc-maintenance-checkbox-list>
			<parc-technologie-checkbox-list [id]="'choixTechnologie'"
				[labelClass]="'col-md-1'" [fieldClass]="'col-md-2 plus-half'"
				[resetCommands]="resetCommands" (selectionIdsChange)="parcTechnoFilterChange($event)"
				>
			</parc-technologie-checkbox-list>
			<type-acces-checkbox-list [id]="'choixTypeAcces'"
				[labelClass]="'col-md-1'" [fieldClass]="'col-md-2 plus-half'"
				[resetCommands]="resetCommands" (selectionIdsChange)="typeAccesFilterChange($event)"
				>
			</type-acces-checkbox-list>
		</div>
		<div class="form-group">
			<div class="col-sm-6 text-center">
				<!-- bouton disabled si aucun critère posé sur les dates -->
				<button type="button" class="btn btn-success" (click)="applyfilters()" 
					[disabled]="!searchCriteria.critereDate && !searchCriteria.dateMin && !searchCriteria.dateMax">Filtrer
				</button>
			</div>
			<div class="col-sm-6 text-center">
				<button type="button" class="btn btn-primary" (click)="resetfilters()">Réinitialiser</button>
			</div>
		</div>
	</form>
</pannel>